// extracted by mini-css-extract-plugin
export default {"nav":"Nav-module--nav--32g51","navItem":"Nav-module--navItem--2QpsS","navActive":"Nav-module--navActive--1Olxp"};